import { N16_04 } from "./N16_04";

export const N16_03 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "Territory",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Territory",
        binding: {
          data: {
            columns: [
              {
                name: "Territory",
                columnName: "TerritoryName",
                width: "400px",
                align: "left",
                sortable: true
              },
              {
                name: "Agent Name",
                columnName: "AgentName",
                width: "400px",
                align: "left",
                sortable: true
              },
              {
                name: "Total Count",
                columnName: "TotalCount",
                width: "180px",
                align: "center",
                sortable: true
              },
            ],
            title: "TerritoryName",
            endpoint: "N16.3",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: N16_04,
            },
          },
        },
      },
    },
  ],
};